export default __webpack_public_path__ + "static/media/counter.4f9fc550.png";